<micro-lookup domain="ai" obj="chatApps" url="/chatApps" [key]="chatAppId"></micro-lookup>
